module.exports = __webpack_public_path__ + "static/img/1060_big.53ee470.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1060_big.png
// module id = BX91
// module chunks = 1